import { baseEnv } from './base';

export const stageEnv = {
  baseUrl: {
    notification: `https://api.notification.${baseEnv.domain.stage}`,
  },
};
